import * as React from 'react';

import { Alert } from 'components/bootstrap';

const DataWarehouseBackendWarning = () => (
  <Alert bsStyle="warning">Note that for the active back-end to be changed, all data must first be deleted from the current back-end.</Alert>
);

export default DataWarehouseBackendWarning;
